import copyIcon from '@iconify/icons-material-symbols/content-copy-outline-rounded';
import type { ComponentProps, MouseEvent, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useCopyToClipboard } from 'usehooks-ts';
import { cn } from '#pie/utils/TailwindUtils';
import { IconButton } from '../icon-button/IconButton';
import { useToast } from '../toast/ToastContext';

interface Props
  extends PropsWithChildren,
    React.HTMLAttributes<HTMLSpanElement> {
  content: string;
  as?: ComponentProps<typeof IconButton>['as'];
}

export const CopyButton = ({
  as,
  children,
  content,
  className,
  ...props
}: Props) => {
  const [_, copy] = useCopyToClipboard();
  const { addToast } = useToast();
  const { t } = useTranslation('common');

  const onCopy = (_e: MouseEvent<HTMLButtonElement>) => {
    copy(content);
    addToast({
      message: `${content} is gekopieerd naar het klembord`,
      title: 'Gekopieeerd!',
      type: 'info',
    });
  };

  return (
    <span className={cn('group', className)} {...props}>
      {children}
      <IconButton
        as={as}
        variant="primary"
        size={16}
        icon={copyIcon}
        aria-label={`${content} ${t('common.button.copy.aria-label')}`}
        onClick={onCopy}
        className="border-none relative z-20 ml-1 -translate-x-2 align-[-10%] opacity-0 transition group-hover:translate-x-0 group-hover:opacity-100"
      />
    </span>
  );
};
